import React from 'react';
import styled from 'styled-components';
import MaterialAliasFilterStation from './MaterialAliasFilterStation';

const MaterialAliasMetaStation: React.FC = () => (
  <MetaStationContainer>
    <MaterialAliasFilterStation />
  </MetaStationContainer>
);

const MetaStationContainer = styled.div`
  width: 100%;
  height: calc(9vh);
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 5vw;
  margin-bottom: 0.5vh;
`;

export default MaterialAliasMetaStation;
